import S from './VehiclesDistanceWidgetStyles';
import EntityRating from '../common/EntityRating/EntityRating';
import useGetVehicles from '../../API/hooks/vehicles/useGetVehicles';
import { queryFilterByGroups, queryFilters } from '../../utils/queryFilters';
import { resolveFreshQueryResults } from '../../utils/resolveFreshQueryResults';
import GlobalSpinner from '../common/GlobalSpinner/GlobalSpinner';
import { TimePeriod } from '../../constants/TimePeriod';

type Props = {
  fleetId: string;
  period: string;
  groupFilters?: Record<string, any>;
};

type DistanceField = 'distanceInKmDaily' | 'distanceInKmWeekly' | 'distanceInKmMonthly' | 'distanceInKmTotal';

const PERIOD_TO_DISTANCE_FIELD: Record<string, DistanceField> = {
  daily: 'distanceInKmDaily',
  weekly: 'distanceInKmWeekly',
  monthly: 'distanceInKmMonthly',
};

function VehiclesDistanceWidget({
  fleetId, period = 'monthly', groupFilters,
}: Props): JSX.Element {
  const distanceField: DistanceField = PERIOD_TO_DISTANCE_FIELD[period] ?? 'distanceInKmTotal';
  const periodLabel = (TimePeriod as any)[period] ?? TimePeriod.all;

  const {
    data: topVehicles,
    isLoading: isTopLoading,
    isPreviousData: isTopPreviousData,
  } = useGetVehicles(fleetId, queryFilters({
    sortBy: [`${distanceField}_DESC`],
  }, 1, `${queryFilterByGroups(groupFilters)}`, '', 3));
  const {
    data: lowVehicles,
    isLoading: isLowLoading,
    isPreviousData: isLowPreviousData,
  } = useGetVehicles(fleetId, queryFilters({
    sortBy: [`${distanceField}_ASC`],
  }, 1, `${queryFilterByGroups(groupFilters)}`, '', 3));

  if (isTopLoading && isLowLoading) {
    return (
      <S.Wrapper>
        <GlobalSpinner />
      </S.Wrapper>
    );
  }

  return (
    <S.Wrapper>
      <EntityRating
        title={`Top vehicle km • ${periodLabel}`}
        entities={period === 'custom' ? [] : resolveFreshQueryResults(topVehicles, isTopPreviousData)}
        ratingField={distanceField}
        entityType="vehicle"
        isLoading={isTopLoading}
        emptyMessage={period === 'custom' ? 'No data available for custom period' : undefined}
      />
      <div className="horizont-line" />
      <EntityRating
        title={`Lowest vehicle km • ${periodLabel}`}
        entities={period === 'custom' ? [] : resolveFreshQueryResults(lowVehicles, isLowPreviousData)}
        ratingField={distanceField}
        entityType="vehicle"
        isLoading={isLowLoading}
        emptyMessage={period === 'custom' ? 'No data available for custom period' : undefined}
      />
    </S.Wrapper>
  );
}

export default VehiclesDistanceWidget;
